<template>
    <svg viewBox="0 0 320 200" class="discovery-scene" aria-hidden="true" focusable="false">
        <ellipse cx="166" cy="115" rx="112" ry="66" fill="var(--art-soft)" transform="rotate(-10 166 115)" />
        <g class="discovery-scene__objects" stroke-linecap="round" stroke-linejoin="round">
            <g v-if="scene === 'products'">
                <path d="M99 69V37h21v32q14 10 14 26v66H85V95q0-16 14-26" fill="var(--art-deep)" />
                <rect x="92" y="103" width="35" height="36" rx="3" fill="white" />
                <path d="M99 38h21" stroke="var(--art-accent)" stroke-width="9" />
                <rect x="155" y="74" width="65" height="87" rx="7" fill="#e8c89c" />
                <path d="M155 74h65l-12-20h-41z" fill="#f4e3c9" />
                <rect x="169" y="101" width="37" height="24" rx="4" fill="white" />
                <path d="M178 111h19m-19 6h12" stroke="var(--art-accent)" stroke-width="3" />
            </g>
            <g v-else-if="scene === 'customers'" transform="rotate(-7 160 100)">
                <rect x="88" y="39" width="145" height="124" rx="11" fill="var(--art-accent)" />
                <rect x="97" y="47" width="127" height="108" rx="6" fill="white" />
                <path d="M83 66h20m-20 24h20m-20 24h20m-20 24h20" stroke="var(--art-deep)" stroke-width="5" />
                <circle cx="143" cy="81" r="15" fill="var(--art-soft)" />
                <path d="M119 115q0-29 24-29t24 29" fill="var(--art-accent)" />
                <path d="M181 76h25m-25 15h19M120 135h86" stroke="var(--art-accent)" stroke-width="5" />
            </g>
            <g v-else-if="scene === 'providers'">
                <path d="M84 71h151v90H84z" fill="white" stroke="#dedbe7" />
                <path d="m75 72 85-44 85 44z" fill="var(--art-deep)" />
                <path d="M129 102h63v59h-63z" fill="var(--art-accent)" />
                <path d="M137 115h47m-47 13h47m-47 13h47" stroke="white" stroke-width="3" />
                <path d="M94 91h18v21H94zm112 0h18v21h-18z" fill="var(--art-soft)" />
                <path d="M70 147h36v24H70z" fill="#d8ae7e" /><path d="M88 147v24" stroke="#f5e4c8" stroke-width="7" />
            </g>
            <g v-else-if="scene === 'catalog'">
                <path d="M160 54q-38-25-77-13v116q39-12 77 10 38-22 77-10V41q-39-12-77 13" fill="white" stroke="#dedbe7" />
                <path d="M160 54v113" stroke="var(--art-accent)" stroke-width="3" />
                <rect x="99" y="65" width="43" height="43" rx="5" fill="var(--art-soft)" /><path d="M112 76h17v24h-17z" fill="var(--art-accent)" />
                <rect x="178" y="67" width="43" height="43" rx="5" fill="var(--art-soft)" /><circle cx="200" cy="88" r="12" fill="var(--art-accent)" />
                <path d="M99 125h43m-43 12h30m49-12h43m-43 12h30" stroke="var(--art-accent)" stroke-width="4" />
            </g>
            <g v-else-if="scene === 'team'">
                <circle cx="160" cy="66" r="22" fill="var(--art-deep)" />
                <circle cx="103" cy="84" r="17" fill="var(--art-accent)" /><circle cx="217" cy="84" r="17" fill="#d9ae7f" />
                <path d="M75 151v-20q0-31 28-31t28 31v20" fill="var(--art-accent)" />
                <path d="M189 151v-20q0-31 28-31t28 31v20" fill="#d9ae7f" />
                <path d="M121 162v-36q0-39 39-39t39 39v36" fill="var(--art-deep)" />
                <path d="M150 126h20m-10-10v20" stroke="white" stroke-width="5" />
            </g>
            <g v-else-if="scene === 'projects'">
                <rect x="78" y="39" width="164" height="121" rx="9" fill="white" stroke="#dedbe7" />
                <path d="M93 58h31m17 0h31m17 0h31" stroke="var(--art-deep)" stroke-width="5" />
                <rect x="91" y="73" width="36" height="29" rx="4" fill="var(--art-soft)" /><rect x="91" y="109" width="36" height="29" rx="4" fill="var(--art-soft)" />
                <rect x="142" y="73" width="36" height="43" rx="4" fill="var(--art-accent)" /><rect x="193" y="73" width="36" height="29" rx="4" fill="#8ab99f" />
                <path d="m202 87 5 5 12-12" fill="none" stroke="white" stroke-width="3" />
                <path d="M99 83h20m-20 36h20m31-36h20m-20 12h14" stroke="white" stroke-width="3" />
            </g>
            <g v-else-if="scene === 'sales'">
                <path d="M79 52h18l18 87h103l17-64H104" fill="white" stroke="var(--art-deep)" stroke-width="6" />
                <path d="M126 91h91m-86 19h80m-65-34 5 55m29-55-3 55" stroke="var(--art-accent)" stroke-width="3" />
                <rect x="130" y="38" width="39" height="37" rx="5" fill="var(--art-accent)" transform="rotate(-8 150 56)" />
                <path d="M185 73V45h25v28" fill="#e4ba82" />
                <circle cx="129" cy="155" r="11" fill="var(--art-deep)" /><circle cx="209" cy="155" r="11" fill="var(--art-deep)" />
            </g>
            <g v-else-if="scene === 'invoice'" transform="rotate(-6 160 100)">
                <path d="M105 25h88l25 25v124l-13-7-13 7-13-7-13 7-13-7-13 7-13-7-22 7z" fill="white" stroke="#dedbe7" />
                <path d="M193 25v25h25" fill="var(--art-soft)" />
                <text x="124" y="73" font-size="29" font-weight="600" fill="var(--art-deep)">€</text>
                <path d="M126 91h69m-69 16h54m-54 16h69" stroke="var(--art-accent)" stroke-width="5" />
                <path d="M164 148h31" stroke="var(--art-deep)" stroke-width="7" />
            </g>
            <g v-else-if="scene === 'purchases'">
                <rect x="93" y="37" width="78" height="91" rx="8" fill="white" stroke="#dedbe7" transform="rotate(-12 132 80)" />
                <path d="M112 57h37m-37 15h30m-30 15h34" stroke="var(--art-accent)" stroke-width="4" />
                <path d="M151 91h86l-11 73h-64z" fill="var(--art-accent)" />
                <path d="m166 91 15-34m39 34-15-34" stroke="var(--art-deep)" stroke-width="6" />
                <path d="M177 111v33m17-33v33m17-33v33" stroke="white" stroke-width="5" />
            </g>
            <g v-else-if="scene === 'folder'">
                <path d="M80 64V45q0-9 10-9h47l16 18h73q10 0 10 10v95H80z" fill="var(--art-accent)" />
                <rect x="101" y="48" width="104" height="99" rx="5" fill="white" transform="rotate(6 153 98)" />
                <path d="M120 70h59m-59 14h45m-45 14h60" stroke="var(--art-accent)" stroke-width="4" />
                <path d="M80 85h157l-13 78H89z" fill="var(--art-deep)" />
                <rect x="133" y="110" width="51" height="19" rx="4" fill="var(--art-soft)" />
            </g>
            <g v-else-if="scene === 'stock'">
                <path d="M88 33v137m143-137v137M88 98h143M88 161h143" stroke="var(--art-deep)" stroke-width="7" />
                <path d="M101 54h47v40h-47zm65-13h49v53h-49zM101 115h55v42h-55zm68 0h46v42h-46z" fill="#dfb98c" />
                <path d="M124 54v40m66-53v53m-62 21v42m64-42v42" stroke="#f6e7d4" stroke-width="10" />
            </g>
            <g v-else-if="scene === 'truck'">
                <rect x="73" y="58" width="113" height="86" rx="9" fill="var(--art-accent)" />
                <path d="M186 83h39l29 34v27h-68z" fill="var(--art-deep)" />
                <path d="M196 93h23l18 24h-41z" fill="white" />
                <path d="M92 84h56m-56 16h39" stroke="white" stroke-width="5" />
                <circle cx="107" cy="145" r="17" fill="#514b60" /><circle cx="223" cy="145" r="17" fill="#514b60" />
                <circle cx="107" cy="145" r="7" fill="white" /><circle cx="223" cy="145" r="7" fill="white" />
                <path d="M42 113h18m-9 14h9" stroke="var(--art-accent)" stroke-width="4" />
            </g>
            <g v-else-if="scene === 'delivery'">
                <path d="m105 100 54-24 55 24v59l-55 24-54-24z" fill="#d9b184" />
                <path d="m105 100 54 25 55-25m-55 25v58" fill="none" stroke="#ad8054" stroke-width="2" />
                <path d="m105 100-23-25 55-23 22 24 23-24 56 23-24 25-55-24z" fill="#f0d9bc" />
                <path d="M159 22v49m-14-14 14 14 14-14" fill="none" stroke="var(--art-deep)" stroke-width="7" />
            </g>
            <g v-else-if="scene === 'shop'">
                <rect x="94" y="65" width="134" height="101" rx="6" fill="white" />
                <path d="m88 72 17-34h113l17 34v16q-15 15-29 0-15 15-30 0-15 15-29 0-15 15-29 0-15 15-30 0z" fill="var(--art-accent)" />
                <path d="m125 38-8 34m42-34v34m37-34 9 34" stroke="white" stroke-width="14" />
                <rect x="110" y="108" width="48" height="36" rx="3" fill="var(--art-soft)" /><rect x="176" y="105" width="34" height="61" rx="3" fill="var(--art-deep)" />
            </g>
            <g v-else-if="scene === 'tasks'" transform="rotate(-7 160 100)">
                <rect x="105" y="28" width="112" height="149" rx="9" fill="var(--art-accent)" />
                <rect x="113" y="39" width="96" height="129" rx="4" fill="white" />
                <rect x="138" y="22" width="47" height="23" rx="7" fill="var(--art-deep)" />
                <path d="m126 70 5 5 9-11m-14 34 5 5 9-11" fill="none" stroke="var(--art-deep)" stroke-width="4" />
                <path d="M152 71h40m-40 28h40m-40 28h30" stroke="var(--art-accent)" stroke-width="5" />
                <rect x="125" y="121" width="14" height="14" rx="3" fill="var(--art-soft)" />
                <path d="m225 86-24 72" stroke="#dbab65" stroke-width="9" />
            </g>
            <g v-else-if="scene === 'calendar'">
                <rect x="89" y="42" width="143" height="120" rx="12" fill="white" stroke="#dedbe7" />
                <path d="M101 42h119q12 0 12 12v23H89V54q0-12 12-12" fill="var(--art-accent)" />
                <path d="M119 30v26m82-26v26" stroke="var(--art-deep)" stroke-width="7" />
                <path d="M109 96h12m20 0h12m20 0h12m20 0h8m-104 23h12m20 0h12m20 0h12m20 0h8m-104 23h12m20 0h12" stroke="var(--art-soft)" stroke-width="10" />
                <circle cx="180" cy="119" r="14" fill="var(--art-deep)" /><path d="m173 119 5 5 9-10" fill="none" stroke="white" stroke-width="3" />
            </g>
            <g v-else-if="scene === 'pos'">
                <path d="m92 114 16-42h108l17 42v47H92z" fill="var(--art-accent)" />
                <rect x="139" y="31" width="72" height="43" rx="7" fill="var(--art-deep)" /><rect x="146" y="38" width="58" height="27" rx="3" fill="white" />
                <path d="M159 51h32" stroke="var(--art-accent)" stroke-width="4" />
                <path d="M111 89h10m8 0h10m-28 13h10m8 0h10" stroke="white" stroke-width="6" />
                <rect x="157" y="85" width="46" height="20" rx="4" fill="var(--art-soft)" />
                <rect x="103" y="125" width="119" height="23" rx="4" fill="var(--art-deep)" /><path d="M151 137h23" stroke="white" stroke-width="3" />
                <path d="M111 72V30h19v42" fill="white" stroke="#dedbe7" />
            </g>
        </g>
        <path d="m62 48 3 7 7 3-7 3-3 7-3-7-7-3 7-3zM258 143l2 5 5 2-5 2-2 5-2-5-5-2 5-2z" fill="var(--art-accent)" />
    </svg>
</template>
<script>
export default { props: { scene: { type: String, required: true } } };
</script>
<style scoped>
.discovery-scene { display: block; width: 100%; height: 200px; margin-top: auto; }
.discovery-scene__objects { transform-origin: 160px 100px; transition: transform .35s ease; }
article:hover .discovery-scene__objects, article:focus-within .discovery-scene__objects { transform: translateY(-4px) rotate(-2deg); }
@media (prefers-reduced-motion: reduce) { .discovery-scene__objects { transition: none; transform: none !important; } }
</style>
